import React, { Component } from 'react'
import { connect } from 'react-redux'
import landlords from 'selectors/landlords'
import * as R from 'ramda'
import { getByType } from 'utils/stuff'

import LeftNav from 'material-ui/Drawer'

import LeftNavMenu from 'components/LeftNavMenu'
import AttachmentOverlay from 'components/AttachmentOverlay'
import RightPanel from 'components/RightPanel/'
import PortfoliosList from './PortfoliosList'
import ActionBar from './ActionBar'

import actionBarActions from 'actions/actionbar'
import taskFiltersActions from 'actions/taskFilters'
import rightStackActions from 'actions/rightStackActions'
import attachmentOverlayActions from 'actions/attachmentOverlayActions'
import dataActions from 'actions/dataActions'
import Error from 'components/Error'

let select = (state) => ({
	...state
  , projects: getByType(state, 'project')
  , tasks: getByType(state, 'task')
  , landlords: landlords(state)
  })
export class Tasks extends Component {
	render() {
		try {
			return(
				<div>
					<AttachmentOverlay
						file={this.props.attachmentOverlay.file}
						name={this.props.attachmentOverlay.name}
						show={this.props.attachmentOverlay.show}
						close={this.props.ATTACHMENT_CLOSE}
					/>
					<ActionBar
						navPanelIsOpened={this.props.actionBarReducers.leftNav}
						rightStackOpened={this.props.rightStack.listOfOpened.length}
						filtersIsOpened={this.props.actionBarReducers.rightNav}
						handleToggleLeft={this.props.TOOGLE_LEFT_NAV}
						handleToggleFilters={this.props.TOOGLE_FILTERS_PANEL}
						count={R.values(this.props.landlords).length}
						openPanel={this.props.OPEN_PANEL}
						triggerPrompt={this.props.TRIGGER_PROMPT}
						clearFilters={() => this.props.TASK_FILTER_UPDATED({
		  					open: "true"
		  				  , owner: 'All'
		  				  , landlord: 'All'
		  				  , property: 'All'
		  				  , tenant: 'All'
		  				  , urgent: "All"
		  				  , dueFrom: new Date(new Date().valueOf() - 24 * 60 * 60 * 1000)
		  				  , dueTo: new Date(new Date().valueOf() + 7 * 24 * 60 * 60 * 1000)
		  				  , minDue: new Date(new Date().valueOf() - 24 * 60 * 60 * 1000)
		  				  , maxDue: new Date(new Date().valueOf() + 7 * 60 * 60 * 1000)
					  	})}
						updateFunction={(id) =>{
							if(this.props.projects[this.props.task[id].projectID].tasks.length != 1){
								this.props.DOC_UPDATE({
									...this.props.projects[this.props.task[id].projectID]
								  ,	tasks: R.reject(
										(task) => task == id
									  , this.props.projects[this.props.task[id].projectID].tasks
									)
								})
								this.props.projects[this.props.task[id].projectID].tasks.map(
									(taskID) => {
										this.props.DOC_UPDATE({
											_id: taskID
										  , dependencies: R.reject(
												dep => (dep == id)
											  , this.props.task[taskID].dependencies
										  )
									  })
									}
								)
							} else {
								this.props.DOC_DELETE({
									id: this.props.task[id].projectID
								})
							}
						}}
					/>
					<div className="flex-box">
						<PortfoliosList
							portfolios={this.props.landlords}
							openPanel={this.props.OPEN_PANEL}
							filtersIsOpened={this.props.actionBarReducers.rightNav}
							rightStackOpened={this.props.rightStack.listOfOpened.length}
							navPanelIsOpened={this.props.actionBarReducers.leftNav}
							lastInteracted={(this.props.rightStack.listOfOpened.length)?
								this.props.rightStack.listOfOpened[this.props.rightStack.listOfOpened.length - 1].id
								: ''
							}
						/>
						<RightPanel
							stack={this.props.rightStack}
							closePanel={this.props.CLOSE_PANEL}
							deleteFunction={(id) => this.props.DOC_DELETE(id)}
							filtersIsOpened={this.props.actionBarReducers.rightNav}
							openPanel={this.props.OPEN_PANEL}
							triggerPrompt={this.props.TRIGGER_PROMPT}
							clearFilters={() => this.props.TASK_FILTER_UPDATED({
			  					open: "true"
			  				  , owner: 'All'
			  				  , landlord: 'All'
			  				  , property: 'All'
			  				  , tenant: 'All'
			  				  , urgent: "All"
			  				  , dueFrom: new Date(new Date().valueOf() - 24 * 60 * 60 * 1000)
			  				  , dueTo: new Date(new Date().valueOf() + 7 * 24 * 60 * 60 * 1000)
			  				  , minDue: new Date(new Date().valueOf() - 24 * 60 * 60 * 1000)
			  				  , maxDue: new Date(new Date().valueOf() + 7 * 60 * 60 * 1000)
						  	})}
							updateFunction={(id) =>{
								if(this.props.data.projects_db[this.props.data.tasks_db[id].projectID].tasks.length != 1){
									this.props.DOC_UPDATE({
										...this.props.data.projects_db[this.props.data.tasks_db[id].projectID]
									  ,	tasks: R.reject(
											(task) => task == id
										  , this.props.data.projects_db[this.props.data.tasks_db[id].projectID].tasks
										)
									})
									this.props.data.projects_db[this.props.data.tasks_db[id].projectID].tasks.map(
										(taskID) => {
											this.props.DOC_UPDATE({
												_id: taskID
											  , dependencies: R.reject(
													dep => (dep == id)
												  , this.props.data.tasks_db[taskID].dependencies
												)
										  })
										}
									)
								} else {
									this.props.DOC_DELETE(this.props.data.tasks_db[id].projectID)
								}
							}}
						/>
					</div>
				</div>
			)
		}catch(err){
			console.error(err)
			return(<Error />)
		}
	}
}

export default connect(select, R.mergeAll([actionBarActions, taskFiltersActions, rightStackActions, attachmentOverlayActions, dataActions]))(Tasks)



// WEBPACK FOOTER //
// ./src/routes/manager/portfolios/index.js